import {
  AppBar,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  DialogContent,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { Close as CloseIcon, ControlPointSharp, FlareSharp } from "@mui/icons-material";
import { useFormik } from "formik";
import { DateTime } from "luxon";
import { connect } from "react-redux";
import "./ArticleForm.css";

import { axios, getBackgroundColor, topicEntries } from "../../commons";

import React from "react";
// import ReactDOM from "react-dom";
import ImageUploading from "react-images-uploading";

// 2022.11 텍스트 에디터 추가로 사용
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// 에디터 안의 이미지 사이즈 조절
import ImageResize from 'quill-image-resize';
Quill.register('modules/ImageResize', ImageResize);

var removingFiles = "";

const ArticleForm = ({ member, initialValues, onStartProcess, onClose }) => {
  let initImageList = [];
  if (initialValues.files) {
    initImageList = initialValues.files.map((p, i) => ({
      data_url: p.url,
      fileId: p.id,
    }));
  }

  const [images, setImages] = React.useState(initImageList);
  const maxNumber = 10;
  const onChange = (imageList) => {
    setFieldValue(
      "files",
      imageList.map(({ file }) => file)
    );
    setImages(imageList);
  };

  const [value, setValue] = React.useState(''); // 에디터 내용을 담는 변수
  const quillRef = React.useRef(null);  // 에디터 객체를 가리킴

  // 첨부파일 이미지 삭제 메소드
  function imageRemove(index) {
    removingFiles = removingFiles + index.fileId + ",";
  }

  // 게시글 삭제 메소드
  async function deleteArticle() {
    const { userId, id } = initialValues;

    if (!id) {
      window.alert("새 Article은 삭제 대상이 아닙니다.");
      return;
    }
    if (
      id &&
      userId !== member.userId &&
      !window.confirm("작성자가 본인이 아닙니다. 그래도 삭제하시겠습니까?")
    ) {
      return;
    }

    try {
      // 서버에 해당 게시글 삭제 요청
      const { status } = await axios(
        `/api/board/articles${id ? `/${id}` : ""}`,
        {
          method: "DELETE",
        }
      );

      console.log({ status });
      onClose(true);
    } catch (err) {
      console.error(err);

      if (err.response) {
        alert(err.response.data.error);
      }
    }
  }

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues:
      initialValues === true
        ? {
            topic: "",
            content: "",
            //picture: [],
          }
        : initialValues,
    validateOnMount: true,
    validate: ({ topic, content }) => {
      const result = {};

      if (!topic) {
        result.topic = "필수!";
      }

      // if (!content.trim()) {
      //   result.content = "필수!";
      // }

      return result;
    },
    onSubmit: async (finalValues) => {
      const { userId, id } = initialValues;

      // 글 작성자인지 판단
      if (
        id &&
        userId !== member.userId &&
        !window.confirm("작성자가 본인이 아닙니다. 그래도 수정하시겠습니까?")
      ) {
        return;
      }

      // 에디터 내용 유무
      if(!value) {
        alert("본문을 입력해주세요.");
        return;
      }

      try {
        const fd = new FormData();
        const { topic, content, files } = finalValues;

        const imageFiles = convertImage();  // 에디터의 base64 이미지를 input 태그에 file객체로 담음
        const sort = sortContent(imageFiles); // editor의 image를 파일명으로 변경

        // 파일 용량 확인
        if(!fileCheck(imageFiles.files, files)) {
          alert('이미지 총 용량이 10MB를 초과할 수 없습니다. 이미지를 수정해주세요.');
          return;
        } else {
          // 업로드 파일이 10MB가 넘지 않은 경우
          onStartProcess();
        
          fd.append("topic", topic);
          fd.append("content", JSON.stringify(sort));

          files &&
          files.forEach((file) => {
            fd.append("picture", file);
          });

          for(let i=0; i<imageFiles.files.length; i++) {
            fd.append("picture", imageFiles.files.item(i));
          }
          
          // 에디터 내용의 삭제된 이미지 확인하기
          let removingFileList = removingFiles !== '' ? removingFiles + checkRemovingImages() : checkRemovingImages();
          fd.append("removingFiles", removingFileList);
          // console.log("fd.removingFiles", fd.removingFiles);
          // for (var pair of fd.entries()) {
          //   console.log(pair[0] + ", " + pair[1]);
          // }

          const { status } = await axios(
            `/api/board/articles${id ? `/${id}` : ""}`,
            {
              method: id ? "PATCH" : "POST",
              headers: {
                "Content-Type": "multipart/form-data",
              },
              data: fd,
            }
          );

          console.log({ status });
          removingFiles = "";
          onClose(true);
        }
      } catch (err) {
        console.error(err);

        if (err.response) {
          alert(err.response.data.error);
          onClose(true);
        }
      }
    },
  });

  const formProps = { onBlur: handleBlur, onChange: handleChange };

  React.useEffect(() => {
    // 비디오 핸들러 추가
    if(quillRef.current) {
      const toolbar = quillRef.current.getEditor().getModule('toolbar');
      toolbar.addHandler('video', videoHandler);
    }
    if(values.content !== '') {
      let parseContent = '';
      // delta 값인 경우
      if(values.content.indexOf('insert') > -1) {
        parseContent = {'ops': JSON.parse(values.content)};
      } else {
        parseContent = values.content;
      }
      setValue(parseContent);
    }
  }, []);

  // 에디터의 이미지 파일을 input 객체로 변환
  const convertImage = () => {
    const { editor } = quillRef.current;
    const content = editor.getContents().ops; // 에디터의 contents
    const dataTranster = new DataTransfer();  // input 객체에 넣기 위한 객체

    const input = document.createElement('input');  // input 객체
    input.setAttribute('type', 'file');
    input.setAttribute('multiple', 'multiple');

    for(let i in content) {
      const insert = content[i].insert;
      if(insert.image !== undefined) {
        // base64 인지 아닌지
        let index = JSON.stringify(insert.image).indexOf('base64');

        if(index > -1) {
          // 파일 객체로 변환
          let file = dataUrlToFile(insert.image, i);
          dataTranster.items.add(file);
        }
      }
    }
    input.files = dataTranster.files;
    return input;
  }

  // 이미지 base64를 파일 객체로 반환
  const dataUrlToFile = (dataUrl, num) => {
    var arr = dataUrl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    // 파일명 랜덤으로 설정
    let filename = `${Math.random().toString(36).substring(2, 11)}`;
    return new File([u8arr], `imagepicker_${filename}_${num}.png`, {type:mime});
  }

  /// 에디터의 base64 이미지를 이미지명으로 변경하는 메소드 
  const sortContent = (images) => {
    const { editor } = quillRef.current;
    let copyContent = JSON.parse(JSON.stringify(editor.getContents()));
    let contents = copyContent.ops; // 에디터의 내용을 delta 값으로 변환
    let sort = [];
    let cnt = 0;

    // delta내용을 반복
    for(let i in contents) {
      const content = contents[i];
      if(content.insert.image !== undefined) {
        // base64인지 아닌지
        let index = JSON.stringify(content.insert.image).indexOf('base64');

        if(index > -1) {
          // base64 이미지는 file로 객체로 변경
          content.insert.image = images.files[cnt].name;
          sort.push(content);
          cnt++;
        } else {
          // base64가 아닌 이미지는 원래 형태로 sort 리스트에 넣기
          sort.push(content);
        }
      } else if(content.insert.video !== undefined) {
        content.insert.video = getVideoUrl(content.insert.video);
        sort.push(content);
      } else {
        // 이미지가 아닌 내용은 그대로 리스트에 넣기
        sort.push(content);
      } 
    }
    return sort;
  }

  // 에디터 안의 삭제된 이미지 찾기
  const checkRemovingImages = () => {
    const { editor } = quillRef.current;
    const contents = editor.getContents().ops;
    let removing = '';

    if(initialValues.images !== undefined) {
      // 에디터 안의 이미지 수만큼 반복문 실행
      for(let i=0; i<initialValues.images.length; i++) {
        // 에디터 안에 있는 이미지를 찾음
        // find로 리스트안에 내용을 서치할 경우 조건에 맞는 값이 없는 경우엔 undefined로 값을 return한다.
        let value = contents && contents.find((content) => content.insert.image !== undefined
               && content.insert.image.indexOf(initialValues.images[i].gsName) > -1);
        // 에디터 안에 이미지가 없는 경우
        if(value === undefined) {
          removing += initialValues.images[i].id + ',';
        }
      }
    }
    let result = removing.slice(0, -1);
    return result;
  }

  // 파일 용량 체크
  const fileCheck = (editorImages, images) => {
    let totalSize = 0;
    let maxSize = 10 * 1000 * 1000 ; // 총 10mb

    // 에디터 안의 이미지 파일 크기
    if(editorImages !== undefined) {
      for(let i=0; i<editorImages.length; i++) {
        totalSize += editorImages[i].size;
      }
    }

    // 첨부파일 이미지 파일 크기
    if(images !== undefined) {
      for(let i=0; i<images.length; i++) {
        // 첨부 파일의 경우 URL 이미지도 같이 넘어오기 때문에 이미지 파일인 경우만 file 크기 확인
        if(images[i] !== undefined && images[i].size !== undefined) {
          totalSize += images[i].size;
        }
      }
    }

    console.log(`total file size: ${totalSize}`);
    if(totalSize > maxSize) {
      return false;
    }
    return true;
  }

  // 비디오 핸들러
  const videoHandler = () => {
    let url = prompt("Enter Video URL: ");
    url = getVideoUrl(url);
    const editor = quillRef.current.getEditor();  // 에디터 정보 가져옴
    const range = editor.getSelection();  // 에디터의 현재 커서위치
    if (url != null) {
      editor.insertEmbed(range.index, 'video', url);  // 현재 커서위치에 video 추가
    }
  }

  // 비디오 URL 변환
  const getVideoUrl = (url) => {
    let match = '';
    // 유튜브 URL 정규표현식으로 제일 끝에 부분만 자름
    if(url.indexOf('youtube') > -1) {
      match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) ||
      url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/) ||
      url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/) || 
      url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|shorts\/|v=)([^#\&\?]*).*/);
    } else if(url.indexOf('youtu.be') > -1) {
      match = url.match(/^(?:(https?):\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/) ||
        url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/) || 
        url.match(/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|shorts\/|v=)([^#\&\?]*).*/);
    } else {
      return url;
    }

    console.log(match);
    if(match && match[1].length === 11) {
      return ('https') + '://www.youtube.com/embed/' + match[1];
    }
    if (match && match[2].length === 11) {
      // 정리된 결과값과 embed url과 문자열을 합함
      return ('https') + '://www.youtube.com/embed/' + match[2];
    }
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) { // eslint-disable-line no-cond-assign
        return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
    }
    return null;
  }

  // 텍스트 에디터 표시할 항목
  const modules = {
    toolbar: {
      container : [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link','video', 'image'],
        [{ 'align': [] }, { 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      ],
    },
    // 이미지 사이즈 조정
    ImageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize']
    },
  }

  // 에디터 핸들러
  const onHandleChange = (value) => {
    setValue(value);
  }

  return (
    <form style={{height: '98%', overflowY:'auto'}} onSubmit={handleSubmit}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Article
          </Typography>
          <Button
            color="inherit"
            type="button"
            onClick={() => {
              deleteArticle();
            }}
          >
            delete
          </Button>
          <Button color="inherit" type="submit">
            save
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" component={DialogContent}>
        {values.deletedAt && (
          <Card
            sx={{
              m: 1,
              mb: 3,
              bgcolor: (theme) =>
                getBackgroundColor(
                  theme.palette.error.main,
                  theme.palette.mode
                ),
            }}
          >
            <CardHeader title="삭제 정보" />
            <CardContent>
              <TextField
                variant="standard"
                label="삭제 시각"
                value={DateTime.fromISO(values.deletedAt).toLocaleString(
                  DateTime.DATETIME_SHORT
                )}
                InputProps={{ readOnly: true }}
              />
            </CardContent>
          </Card>
        )}

        <Stack spacing={3}>
          <TextField
            variant="standard"
            label="작성자"
            value={
              initialValues.id
                ? `${initialValues.userDisplayName}${
                    initialValues.userId === member.userId ? " (me)" : ""
                  }`
                : `${member.displayName} (me)`
            }
            InputProps={{ readOnly: true }}
          />

          <TextField
            id="filled-select-currency"
            name="topic"
            select
            label="Topic"
            value={values.topic}
            error={touched.topic && !!errors.topic}
            helperText={touched.topic && errors.topic}
            variant="filled"
            sx={{ minWidth: 90 }}
            {...formProps}
          >
            <MenuItem value="">
              <em>선택해주세요.</em>
            </MenuItem>
            {topicEntries.map(([k, v], idx) => (
              <MenuItem value={k} key={idx}>
                {v}
              </MenuItem>
            ))}
          </TextField>

          {/* <TextField
            id="filled-multiline-flexible"
            label="Content"
            multiline
            rows="5"
              name="content"
            value={values.content}
            variant="filled"
            error={touched.content && !!errors.content}
            helperText={touched.content && errors.content}
            {...formProps}
            /> */}

            <ReactQuill
              ref={quillRef}
              style={{height: "380px", overflowX: 'visible'}}
              theme="snow" 
              name="content"
              modules={modules} 
              value={value} 
              onChange={onHandleChange}
            />

          <div style={{marginTop: '60px'}}>
            <ImageUploading
              multiple
              value={images}
              onChange={onChange}
              maxNumber={maxNumber}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps,
              }) => (
                // write your building UI
                <div className="upload__image-wrapper">
                  <Button
                    size="large"
                    variant="outlined"
                    style={isDragging ? { color: "red" } : null}
                    onClick={onImageUpload}
                    {...dragProps}
                  >
                    Click or Drop Photo here
                  </Button>
                  &nbsp;
                  {/* <Button style={{float: 'right'}} size="large" variant="outlined" onClick={onImageRemoveAll}>Remove all images</Button> */}
                  <ImageList cols={3}>
                    {imageList.map((image, index) => (
                      <ImageListItem key={index}>
                        <div key={index} className="image-item">
                          <div className="image-item__btn-wrapper">
                            {/* <Button size="small" onClick={() => {
                              onImageUpdate(index);
                              console.log('after onImageUpdate')                              
                              }
                            }>Update</Button> */}
                            <Button
                              style={{ float: "right" }}
                              size="small"
                              onClick={() => {
                                imageRemove(imageList[index]);
                                onImageRemove(index);
                              }}
                            >
                              Remove
                            </Button>
                          </div>
                          <img src={image.data_url} alt="" width="280" />
                        </div>
                      </ImageListItem>
                    ))}
                  </ImageList>
                </div>
              )}
            </ImageUploading>
          </div>      
          {/* {({ errors }) =>
            errors && (
              <div>
                {errors.maxNumber && (
                  <span>Number of selected images exceed maxNumber</span>
                )}
                {errors.acceptType && (
                  <span>Your selected file type is not allow</span>
                )}
                {errors.maxFileSize && (
                  <span>Selected file size exceed maxFileSize</span>
                )}
                {errors.resolution && (
                  <span>
                    Selected file is not match your desired resolution
                  </span>
                )}
              </div>
            )
          } */}
          {/* {initialValues.files && (
            <ImageList cols={3}>
              {initialValues.files.map((file, idx) => (
                <ImageListItem key={idx}>
                  <img src={file.url} loading="lazy" alt="" />
                </ImageListItem>
              ))}
            </ImageList>
          )} */}
          </Stack>
      </Container>
    </form>
  );
};

const mapState = ({ auth: { member } }) => ({ member });

export default connect(mapState)(ArticleForm);
